import _classCallCheck from "/home/elixx/src/eternal/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/elixx/src/eternal/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/home/elixx/src/eternal/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/elixx/src/eternal/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/home/elixx/src/eternal/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import { Uniform } from "three";
import { BlendFunction } from "./blending/BlendFunction.js";
import { Effect } from "./Effect.js";
var fragment = "uniform float offset;\r\nuniform float darkness;\r\n\r\nvoid mainImage(const in vec4 inputColor, const in vec2 uv, out vec4 outputColor) {\r\n\r\n\tconst vec2 center = vec2(0.5);\r\n\tvec3 color = inputColor.rgb;\r\n\r\n\t#ifdef ESKIL\r\n\r\n\t\tvec2 coord = (uv - center) * vec2(offset);\r\n\t\tcolor = mix(color, vec3(1.0 - darkness), dot(coord, coord));\r\n\r\n\t#else\r\n\r\n\t\tfloat d = distance(uv, center);\r\n\t\tcolor *= smoothstep(0.8, offset * 0.799, d * (darkness + offset));\r\n\r\n\t#endif\r\n\r\n\toutputColor = vec4(color, inputColor.a);\r\n\r\n}\r\n";
/**
 * A vignette effect.
 */

export var VignetteEffect =
/*#__PURE__*/
function (_Effect) {
  _inherits(VignetteEffect, _Effect);

  /**
   * Constructs a new vignette effect.
   *
   * @param {Object} [options] - The options.
   * @param {BlendFunction} [options.blendFunction=BlendFunction.NORMAL] - The blend function of this effect.
   * @param {Boolean} [options.eskil=false] - Enables Eskil's vignette technique.
   * @param {Number} [options.offset=0.5] - The vignette offset.
   * @param {Number} [options.darkness=0.5] - The vignette darkness.
   */
  function VignetteEffect() {
    var _this;

    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, VignetteEffect);

    var settings = Object.assign({
      blendFunction: BlendFunction.NORMAL,
      eskil: false,
      offset: 0.5,
      darkness: 0.5
    }, options);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(VignetteEffect).call(this, "VignetteEffect", fragment, {
      blendFunction: settings.blendFunction,
      uniforms: new Map([["offset", new Uniform(settings.offset)], ["darkness", new Uniform(settings.darkness)]])
    }));
    _this.eskil = settings.eskil;
    return _this;
  }
  /**
   * Indicates whether Eskil's vignette technique is enabled.
   *
   * @type {Boolean}
   */


  _createClass(VignetteEffect, [{
    key: "eskil",
    get: function get() {
      return this.defines.has("ESKIL");
    }
    /**
     * Enables or disables Eskil's vignette technique.
     *
     * You'll need to call {@link EffectPass#recompile} after changing this value.
     *
     * @type {Boolean}
     */
    ,
    set: function set(value) {
      value ? this.defines.set("ESKIL", "1") : this.defines.delete("ESKIL");
    }
  }]);

  return VignetteEffect;
}(Effect);